export default function Toggle({ checked, onChange, disabled = false, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={`relative inline-flex h-6 w-11 shrink-0 rounded-full border transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary/40 ${
        checked
          ? 'bg-theme-primary border-transparent'
          : 'bg-theme-secondary border-theme-secondary'
      } ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 rounded-full shadow-sm transform transition duration-200 ease-in-out mt-0.5 ${
          checked ? 'translate-x-[22px] bg-white' : 'translate-x-0.5 bg-theme-text/35'
        }`}
      />
    </button>
  );
}
